const map = new Map([
  ['MESSAGE_REPLY_ERROR', 'Message not sent, please try again.'],
  ['MESSAGE_REPLY_ERROR_ACTION', 'retry'],
]);

export default map;
